import axios from 'axios';
import api from '../utils/api';
import { getAdminApiBaseUrl } from '../utils/adminApiBase';

const ADMIN_API_BASE = getAdminApiBaseUrl();

class AuthService {
    /** 빈값·공백·문자열 'null'/'undefined'는 비로그인으로 처리 (로그인↔홈 리다이렉트 루프 방지) */
    isUsableToken(token = undefined) {
        const t = token !== undefined ? token : this.getToken();
        if (t == null || typeof t !== 'string') return false;
        const s = t.trim();
        if (!s) return false;
        if (s === 'null' || s === 'undefined') return false;
        return true;
    }

    async login(adminId, password) {
        try {
            // 로그인 요청은 기본 axios를 사용 (헤더에 토큰이 없어야 함)
            const response = await axios.post(
                `${ADMIN_API_BASE}/auth/login`,
                {
                    admin_id: adminId,
                    password,
                },
                { timeout: 20000 }
            );

            if (response.data.token) {
                // 토큰 저장
                localStorage.setItem('admin-token', response.data.token);
                localStorage.setItem('admin-user', JSON.stringify(response.data.admin));

                if (response.data.refreshToken) {
                    localStorage.setItem('admin-refresh-token', response.data.refreshToken);
                }

                // 세션 ID 저장
                if (response.data.sessionId) {
                    localStorage.setItem('admin-session-id', response.data.sessionId);
                    console.log('세션 ID가 저장되었습니다:', response.data.sessionId);
                }

                // 인증 헤더 설정 - 이후 모든 요청에 토큰 포함
                api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                console.log('로그인 성공: 토큰이 저장되었습니다.');

                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Login error:', error);
            if (error?.code === 'ECONNABORTED' || String(error?.message || '').includes('timeout')) {
                throw new Error('연결 시간이 초과되었습니다. 네트워크를 확인 후 다시 시도해주세요.');
            }
            throw new Error(error.response?.data?.message || '로그인 중 오류가 발생했습니다.');
        }
    }

    logout(options = {}) {
        const { redirect = true } = options;
        localStorage.removeItem('admin-token');
        localStorage.removeItem('admin-user');
        localStorage.removeItem('admin-refresh-token');
        localStorage.removeItem('admin-session-id');

        delete api.defaults.headers.common['Authorization'];

        if (redirect && !/\/login\/?$/i.test(window.location.pathname || '')) {
            window.location.replace('/login');
        }
    }

    getToken() {
        return localStorage.getItem('admin-token');
    }

    getRefreshToken() {
        return localStorage.getItem('admin-refresh-token');
    }

    getCurrentUser() {
        const userStr = localStorage.getItem('admin-user');
        if (userStr) return JSON.parse(userStr);
        return null;
    }

    isAuthenticated() {
        const token = this.getToken();
        if (this.isUsableToken(token)) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            return true;
        }
        return false;
    }
}

export default new AuthService();
